import React from "react";
import myImage from "../../Assetes/Images/burgimg.jpg"

let addBtn, cart:any;
const speed = 500,
  curveDelay = 300,
  position = "fixed";

function init() {
 let addBtn:any = document.querySelectorAll("[data-addToCart]");
  cart = document.querySelector("#cart button");
  for (let btn of addBtn) {
    btn.addEventListener("click", addItem);
  }
}

function addItem(e:any) {
  let btnY =
      position === "fixed"
        ? e.currentTarget.getBoundingClientRect().bottom
        : e.currentTarget.offsetBottom,
    btnX =
      position === "fixed"
        ? e.currentTarget.getBoundingClientRect().left
        : e.currentTarget.offsetLeft,
    flyingBtn = e.currentTarget.cloneNode();

  cart.classList.remove("addedCount");

  flyingBtn.classList.add("flyingBtn");
  flyingBtn.style.position = position;
  flyingBtn.style.top = `${btnY}px`;
  flyingBtn.style.left = `${btnX}px`;
  flyingBtn.style.opacity = "1";
  flyingBtn.style.transition = `all ${speed / 1000}s ease, top ${(speed +
    curveDelay) /
    1000}s ease, left ${speed / 1000}s ease, transform ${speed /
    1000}s ease ${(speed - 10) / 1000}s`;

  document.body.appendChild(flyingBtn);

  flyingBtn.style.top = `${cart.offsetTop + cart.offsetHeight - 26}px`;
  flyingBtn.style.left = `${cart.offsetLeft + cart.offsetWidth - 26}px`;
  flyingBtn.style.height = "7rem";
  flyingBtn.style.width = "7rem";
  flyingBtn.style.transform = "scale(0)";

  setTimeout(() => {
    flyingBtn.remove();
  }, speed * 1.5);
}



class Item extends React.Component {
  componentDidMount() {
    init();
  }

  render() {
    return (
      <div className="mt-100 abab">
        
        <header id="header-shop">
          <section id="cart">
            <button>
              <span className="ri-shopping-cart-2-line" />
            </button>
            <ul />
          </section>
        </header>
        <main id="grid-shop">
          <h1>Shop</h1>
          <article>
            
            <footer>
              
              <div>
              <img src="" />
              </div>
              
            </footer>
          </article>
        </main>
        
        <div className="card">
        <img className="" src={myImage} />
  <div className="card-body">
    <h5 className="card-title">Card title</h5>
    <button className="ri-add-line btn btn-primary" onClick={addItem} >Add</button>
  </div>
</div>
      </div>
    );
  }
}

export default Item;
